import React, { useEffect, useState } from 'react';
import { Col, Row, Button, Table, Modal } from 'react-bootstrap';
import InputField from './InputfieldSales';
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { useLocation } from 'react-router-dom';
import baseURL from "../../../../Url/NodeBaseURL";

const PaymentDetails = ({
  paymentDetails,
  setPaymentDetails,
  handleSave,
  handleBack,
  repairDetails,
  setRepairDetails,
  totalPrice,
  schemeSalesData,
  oldSalesData,
  taxableAmount,
  discountAmt,
  totalAmount,
  taxAmount,
  oldItemsAmount,
  schemeAmount,
  netPayableAmount,
  netAmount,
  salesNetAmount,
  salesTaxableAmount,
  salesAmountToPass,
  updatedOldItemsAmount,
  netPayAmount,
  discount,
  handleDiscountChange,
  refreshSalesData,
  offers,
  loading,
  festivalShowModal,
  handleFestivalShowModal,
  handleFestivalCloseModal,
  appliedOffers,
  setAppliedOffers,
  festivalDiscountAmt,
  handleApply,
  isAnyOfferApplied,
  tabId,
  manualNetAmount,
  setManualNetAmount,
  handleManualNetAmountChange,
  isManualNetMode,
  setIsManualNetMode,
  handleManualNetPayAmountChange,
  manualNetPayAmount,
  netPayable
}) => {
  const [isSubmitEnabled, setIsSubmitEnabled] = useState(false);
  const location = useLocation();
  console.log("Location state Cash Amount:", location.state?.cash_amount);

  let rounded = Math.round(netPayableAmount); // Rounds to nearest whole number
  console.log(rounded);

  useEffect(() => {
    const storedPaymentDetails = JSON.parse(localStorage.getItem(`paymentDetails_${tabId}`)) || {};

    console.log("Stored payment details:", storedPaymentDetails);
    console.log("Location state:", location.state);

    // First priority: location.state, second priority: storedPaymentDetails, third: default values
    const cashAmount =
      location.state?.cash_amount !== undefined && location.state.cash_amount !== "" ? location.state.cash_amount :
        storedPaymentDetails.cash_amount !== undefined && storedPaymentDetails.cash_amount !== "" ? storedPaymentDetails.cash_amount :
          "";

    const cardAmt =
      location.state?.card_amt !== undefined && location.state.card_amt !== "" ? location.state.card_amt :
        storedPaymentDetails.card_amt !== undefined && storedPaymentDetails.card_amt !== "" ? storedPaymentDetails.card_amt :
          "";

    const chqAmt =
      location.state?.chq_amt !== undefined && location.state.chq_amt !== "" ? location.state.chq_amt :
        storedPaymentDetails.chq_amt !== undefined && storedPaymentDetails.chq_amt !== "" ? storedPaymentDetails.chq_amt :
          "";

    const onlineAmt =
      location.state?.online_amt !== undefined && location.state.online_amt !== "" ? location.state.online_amt :
        storedPaymentDetails.online_amt !== undefined && storedPaymentDetails.online_amt !== "" ? storedPaymentDetails.online_amt :
          "";

    console.log("Final values - Cash:", cashAmount, "Card:", cardAmt, "Chq:", chqAmt, "Online:", onlineAmt);

    setPaymentDetails({
      cash_amount: cashAmount,
      card_amt: cardAmt,
      chq_amt: chqAmt,
      online_amt: onlineAmt,
    });
  }, [location.state, rounded, tabId]);

  const handlePaymentChange = (field, value) => {
    // Keep as string for input field, but convert to number for calculations
    const stringValue = value === "" ? "" : value;

    // For calculations, convert to number
    const numValue = parseFloat(value) || 0;

    const totalAmount =
      (field === 'cash_amount' ? numValue : parseFloat(paymentDetails.cash_amount || 0)) +
      (field === 'card_amt' ? numValue : parseFloat(paymentDetails.card_amt || 0)) +
      (field === 'chq_amt' ? numValue : parseFloat(paymentDetails.chq_amt || 0)) +
      (field === 'online_amt' ? numValue : parseFloat(paymentDetails.online_amt || 0));

    if (totalAmount > rounded) {
      alert('Total payment amount cannot exceed Net Payable Amount.');
      return;
    }

    const updatedDetails = {
      ...paymentDetails,
      [field]: stringValue
    };

    setPaymentDetails(updatedDetails);

    // Store in localStorage with proper number values for calculations
    const storageDetails = {
      ...updatedDetails,
      cash_amount: parseFloat(updatedDetails.cash_amount) || 0,
      card_amt: parseFloat(updatedDetails.card_amt) || 0,
      chq_amt: parseFloat(updatedDetails.chq_amt) || 0,
      online_amt: parseFloat(updatedDetails.online_amt) || 0
    };

    localStorage.setItem(`paymentDetails_${tabId}`, JSON.stringify(storageDetails));

    console.log("Updated payment details:", updatedDetails);
    console.log("Stored payment details:", storageDetails);
  };

  useEffect(() => {
    const totalEnteredAmount =
      parseFloat(paymentDetails.cash_amount || 0) +
      parseFloat(paymentDetails.card_amt || 0) +
      parseFloat(paymentDetails.chq_amt || 0) +
      parseFloat(paymentDetails.online_amt || 0);

    const tolerance = 0.01; // Small tolerance for floating point precision issues

    setIsSubmitEnabled(Math.abs(totalEnteredAmount - parseFloat(totalPrice || 0)) < tolerance);
  }, [paymentDetails, totalPrice]);

  return (
    <>
      <div>
        <Col className="sales-form-section">
          <Row>
            <h4 className="mb-3" style={{ fontSize: "20px" }}>Summary</h4>
            <Table bordered hover responsive >
              <tr style={{ fontSize: "13px" }}>
                <td colSpan="16" className="text-right">Total Amount</td>
                <td colSpan="4">{totalAmount.toFixed(2)}</td>
              </tr>

              
              <tr style={{ fontSize: "13px" }}>
                <td colSpan="16" className="text-right" >Discount Amount</td>
                <td colSpan="4">
                  {discountAmt.toFixed(2)}
                </td>
              </tr>
              <tr style={{ fontSize: "13px" }}>
                <td colSpan="16" className="text-right" >Taxable Amount</td>
                <td colSpan="4">{taxableAmount.toFixed(2)}</td>
              </tr>
              <tr style={{ fontSize: "13px" }}>
                <td colSpan="16" className="text-right" >Tax Amount</td>
                <td colSpan="4">{taxAmount.toFixed(2)}</td>
              </tr>
              <tr style={{ fontSize: "13px" }}>
                <td colSpan="16" className="text-right" >Net Amount</td>
                <td colSpan="4">{netAmount.toFixed(2)}</td>
              </tr>

              <tr style={{ fontSize: "13px" }}>
                <td colSpan="16" className="text-right" >Old Items Amount</td>
                <td colSpan="4">{oldItemsAmount.toFixed(2)}</td>
              </tr>
              <tr style={{ fontSize: "13px" }}>
                <td colSpan="16" className="text-right" >Net Payable Amount</td>
                {/* <td colSpan="4">
                  <input
                    type="number"
                    style={{ width: '100px', padding: '5px', fontSize: "13px" }}
                    value={netPayable}
                    onChange={handleManualNetPayAmountChange}
                  />
                </td> */}
                <td colSpan="4">
                  <input
                    type="number"
                    style={{ width: '100px', padding: '5px', fontSize: "13px" }}
                    value={
                      isManualNetMode
                        ? manualNetPayAmount
                        : Math.round(netPayableAmount).toFixed(2)
                    }
                    onChange={(e) => {
                      const newValue = parseFloat(e.target.value) || 0;
                      handleManualNetPayAmountChange(newValue);
                    }}
                  />
                </td>
              </tr>
              <tr style={{ fontSize: "13px" }}>
                <td colSpan="16" className="text-right">Balance Amount</td>
                <td colSpan="4">
                  {(
                    Math.round(netPayableAmount) -
                    (parseFloat(paymentDetails.cash_amount || 0) +
                      parseFloat(paymentDetails.card_amt || 0) +
                      parseFloat(paymentDetails.chq_amt || 0) +
                      parseFloat(paymentDetails.online_amt || 0))
                  ).toFixed(2)}
                </td>
              </tr>
            </Table>
          </Row>
        </Col>

        <Col className="sales-form-section">
          <Row>
            <h4 className="mb-3" style={{ fontSize: "18px" }}>Payment Details</h4>
            <Col xs={12} md={4}>
              <InputField
                label="Cash Amt"
                name="cash_amount"
                value={paymentDetails.cash_amount}
                onChange={(e) => handlePaymentChange('cash_amount', e.target.value)}
              />
            </Col>
            <Col xs={12} md={4}>
              <InputField
                label="Card Amt"
                name="card_amt"
                value={paymentDetails.card_amt}
                onChange={(e) => handlePaymentChange('card_amt', e.target.value)}
              />
            </Col>
            <Col xs={12} md={4}>
              <InputField
                label="Cheque Amt"
                name="chq_amt"
                value={paymentDetails.chq_amt}
                onChange={(e) => handlePaymentChange('chq_amt', e.target.value)}
              />
            </Col>
            <Col xs={12} md={4}>
              <InputField
                label="Online Amt"
                name="online_amt"
                value={paymentDetails.online_amt}
                onChange={(e) => handlePaymentChange('online_amt', e.target.value)}
              />
            </Col>
            <Col xs={12} md={3}>
              <Button
                onClick={handleSave}
                style={{
                  backgroundColor: '#a36e29', borderColor: '#a36e29', fontSize: "14px",
                  marginTop: "3px",
                  padding: "4px 8px"
                }}

              >
                Save
              </Button>
            </Col>
            <Col xs={12} md={2}>
              <Button
                variant="secondary"
                onClick={handleBack}
                style={{
                  backgroundColor: 'gray', marginLeft: '-1px', fontSize: "14px",
                  marginTop: "3px",
                  padding: "4px 8px"
                }}
              >
                Cancel
              </Button>
            </Col>
          </Row>
        </Col>
      </div>
    </>
  );
};

export default PaymentDetails;